import { render, staticRenderFns } from "./autoEditLogDetail.vue?vue&type=template&id=04a3abde&scoped=true"
import script from "./autoEditLogDetail.vue?vue&type=script&lang=js"
export * from "./autoEditLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3abde",
  null
  
)

export default component.exports